import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import instagram from '../../instagram.webp'
import youtube from '../../youtube.webp'
import linked from '../../linked.webp'
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className={styles.footer}>
      <div className={styles.footer__container}>
        <nav className={styles.nav}>
          <Link
            to="/about"
            className="text-black text-base font-light uppercase font-inter leading-5 hover:text-orange-500 transition-colors"
          >
            {t("header_footer.about")}
          </Link>
          <Link
            to="/solutions"
            className="text-black text-base font-light uppercase font-inter leading-5 hover:text-orange-500 transition-colors"
          >
            {t("header_footer.service")}
          </Link>

          <Link
            to="/projects"
            className="text-black text-base font-light uppercase font-inter leading-5 hover:text-orange-500 transition-colors"
          >
            {t("header_footer.project")}
          </Link>

          <Link
            to="/contacts"
            className="text-black text-base font-light uppercase font-inter leading-5 hover:text-orange-500 transition-colors"
          >
            {t("header_footer.contact")}
          </Link>

        </nav>
        <div className={styles.social__media}>

          <a href="https://www.instagram.com/neurodesign_com" className="hover:opacity-70 transition-opacity">
            <img
              src={instagram}
              alt="Instagram"
              className="w-[30px] h-[30px]"
            />
          </a>
          <a href="https://www.youtube.com/@NeuroDesignYouTube" className="hover:opacity-70 transition-opacity">
            <img
              src={youtube}
              alt="Youtube"
              className="w-[30px] h-[30px]"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;